import { Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select } from '@mui/material';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import { useContext, useState } from 'react';
import { CampaignMemberStatusContext } from '../../campaign-member-status/CampaignMemberStatusContext';
import { useCampaignMemberStatuses } from '../../campaign-member-status/useCampaignMemberStatuses';

const TypographyText = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body" color={colors.grey[800]}>
    {children}
  </Typography>
);

export const ReplaceStatusDialog = ({
  campaignId,
  statusId,
  onClose,
}: {
  campaignId: string;
  statusId: string;
  onClose: () => void;
}) => {
  const { campaignMemberStatuses } = useContext(CampaignMemberStatusContext);
  const { replaceCampaignMemberStatus, loadCampaignMemberStatuses } = useCampaignMemberStatuses();

  const statuses = campaignMemberStatuses.filter((status) => status.Id !== statusId);
  const [selectedStatus, setSelectedStatus] = useState<string>('');

  const handleReplaceStatus = async () => {
    onClose();
    await replaceCampaignMemberStatus({
      campaignId: campaignId,
      oldStatusId: statusId,
      newStatusId: selectedStatus,
    });
    loadCampaignMemberStatuses(campaignId);
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Replace status before removing</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '400px' }}>
        <TypographyText>
          This status might be in use across campaigns, reports, or automations.
        </TypographyText>
        <TypographyText>
          To prevent data issues, please choose another status to replace it with.
        </TypographyText>
        <TypographyText>Select a replacement status:</TypographyText>
        <Select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
          {statuses.map((status) => (
            <MenuItem key={status.Id} value={status.Id}>
              {status.Label}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button size="medium" variant="system" onClick={onClose}>
          Cancel
        </Button>
        <Button size="medium" variant="primary" disabled={!selectedStatus} onClick={handleReplaceStatus}>
          Replace & Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};
